// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "app/styles/" + chunkId + "." + {"1734": "88606b41027149e4","9568": "0fedfff4fe111b11",}[chunkId] + ".css"
}